import { GET } from "./api";

export const exportData = async (tableName, omit, filter, columnMapping) => {
  const omitParam = encodeURIComponent(JSON.stringify(omit));
  const filterParam = encodeURIComponent(JSON.stringify(filter));
  const columnMappingParam = encodeURIComponent(JSON.stringify(columnMapping));
  const url = `/export/${tableName}?omit=${omitParam}&filter=${filterParam}&columnMapping=${columnMappingParam}`;
  return await GET(url, true, false, false, true);
};